module.exports = __webpack_public_path__ + "img/ava.707e75c2.svg";